import {uniqueId} from '@logistics-frontend/utils'

export const generateUniqueId = (): number => Number(uniqueId(''))
